import ReactQuill from 'react-quill'

// Forma mínima do Parchment do Quill 1.x embutido no react-quill (ver `lineHeight.ts`).
interface IQuillClassAttributor {
  whitelist?: string[]
}

interface IQuillParchment {
  Attributor: {
    Class: new (
      attrName: string,
      keyName: string,
      options: { scope: number; whitelist: string[] }
    ) => IQuillClassAttributor
  }
  Scope: {
    INLINE: number
  }
}

interface IQuillStatic {
  import(name: 'parchment'): IQuillParchment
  register(definition: IQuillClassAttributor, overwrite?: boolean): void
}

/** Fonte oferecida pelo editor dos Banners Home. O `slug` é o que vai para a classe do HTML. */
export interface IRichTextFont {
  slug: string
  name: string
}

/**
 * As fontes que o site já carrega (`next/font` no `layout.tsx` do site-abra-v2) e que o painel
 * carrega no `index.html`. As enviadas pela aba "Fontes" entram depois delas.
 */
export const DEFAULT_BANNER_FONTS: IRichTextFont[] = [
  { slug: 'montserrat', name: 'Montserrat' },
  { slug: 'roboto', name: 'Roboto' },
  { slug: 'georama', name: 'Georama' }
]

// Formato próprio, e não o `font` nativo: a whitelist dele é global, e o `full` do regulamento
// de concurso oferece as fontes padrão do Quill (serif/monospace), que sumiriam com a troca.
// Classe e não estilo porque o site resolve cada uma para a `var(--font-*)` do `next/font`, que
// tem um nome de família com hash — um `font-family: Montserrat` inline não acharia a fonte lá.
const QuillEditor = ReactQuill.Quill as unknown as IQuillStatic
const Parchment = QuillEditor.import('parchment')
const BannerFontClass = new Parchment.Attributor.Class('bannerfont', 'ql-bannerfont', {
  scope: Parchment.Scope.INLINE,
  whitelist: DEFAULT_BANNER_FONTS.map(({ slug }) => slug)
})

QuillEditor.register(BannerFontClass, true)

/**
 * Troca as fontes que o formato aceita. A whitelist é lida quando o Quill interpreta o HTML, então
 * isto roda **antes** de o editor montar: com a fonte fora da lista, abrir um banner que a usa
 * descartaria a classe em silêncio.
 */
export function setBannerFonts(fonts: IRichTextFont[]) {
  BannerFontClass.whitelist = fonts.map(({ slug }) => slug)
}
